import {
    call,
    put,
} from 'redux-saga/effects'
import {
    post,
    get,
} from 'helpers/RequestUtil'
import {
    startFetchScheduleAsync,
    fetchScheduleStart,
    fetchScheduleError,
    fetchScheduleSuccess,
    updateSchedule
} from './actions'

function getEntityData(data){
    if(data.entities.project_schedule_views){
      const schedules = Object.values(data.entities.project_schedule_views)
      if(schedules.length > 0){
        const lastIndex = schedules.length - 1
        if(schedules[lastIndex].data){
          return schedules[lastIndex].data
        }
      }
    }
    return {}
  }
  

function* getSchedule(projectId) {
    try {
        yield put(startFetchScheduleAsync())
        yield put(fetchScheduleStart())
        const data = yield call(
            get,
            `/api/fulcrum/projects/${projectId}/schedules`
        )
        yield put(updateSchedule(getEntityData(data)))
        fetchScheduleSuccess()
    } catch(error) {
        fetchScheduleError(error)
    }
}

function* fetchSchedule(projectId) {
    yield call(getSchedule, projectId)
}

export {
    fetchSchedule
}